/* Clean Bins 360 — signup flow (frontend; Stripe payment wires in later) */
(function () {
  'use strict';
  var root = document.querySelector('[data-signup]');
  if (!root) return;

  var form = document.getElementById('signup-form');
  var steps = Array.prototype.slice.call(root.querySelectorAll('.signup__step'));
  var pSteps = Array.prototype.slice.call(root.querySelectorAll('.signup__progress-step'));
  var current = 0;

  // ---- Config from data attributes ----
  var ZIPS = (root.dataset.zips || '').split(',').map(function (z) { return z.trim(); });
  var PRICES = {
    monthly: { base: +root.dataset.monthlyBase, add: +root.dataset.monthlyAdditional, name: 'Monthly Cleaning', cadence: 'monthly', months: 1 },
    bimonthly: { base: +root.dataset.bimonthlyBase, add: +root.dataset.bimonthlyAdditional, name: 'Bi-Monthly Cleaning', cadence: 'every 2 months', months: 2 },
    quarterly: { base: +root.dataset.quarterlyBase, add: +root.dataset.quarterlyAdditional, name: 'Quarterly Cleaning', cadence: 'quarterly', months: 3 },
    biannual: { base: +root.dataset.biannualBase, add: +root.dataset.biannualAdditional, name: 'Bi-Annual Cleaning', cadence: 'every 6 months', months: 6 },
    ondemand: { base: +root.dataset.ondemandBase, add: +root.dataset.ondemandAdditional, name: 'On Demand', cadence: 'one-time', months: 0 }
  };

  function plan() { var r = form.querySelector('input[name="plan"]:checked'); return r ? r.value : 'quarterly'; }
  function bins() { return parseInt(document.getElementById('bin-count').value, 10) || 2; }

  function priceFor(planKey, n) {
    var p = PRICES[planKey];
    if (planKey === 'ondemand') return p.base + Math.max(0, Math.max(n, 2) - 2) * p.add; // first 2 bins flat, then per-bin
    return n <= 2 ? p.base : p.base + (n - 2) * p.add;
  }

  // ---- Coupon code (client-created Stripe promotion codes; separate from referrals) ----
  var coupon = null; // { percent_off, amount_off(cents), code } from /api/config?promo=
  function couponOff(price) {
    if (!coupon) return 0;
    if (coupon.percent_off) return Math.round(price * coupon.percent_off) / 100;
    if (coupon.amount_off) return Math.min(price, coupon.amount_off / 100);
    return 0;
  }
  // ---- Referral code — disabled for now (Partner Referral Program coming soon) ----
  var referral = null;
  function referralOff() { return 0; }

  // Coupon discount off the first service. Never below $0.50 (Stripe's
  // minimum charge) — the backend applies the same floor, so the two always agree.
  function totalOff(price) { return couponOff(price); }
  function chargeToday(pk, n) {
    var p = priceFor(pk, n);
    return Math.max(0.5, Math.round((p - totalOff(p)) * 100) / 100);
  }

  // ---- Live price on the plan cards (shown for current bin count) ----
  function refreshPlanPrices() {
    var n = bins();
    root.querySelectorAll('[data-plan-price]').forEach(function (el) {
      el.textContent = '$' + priceFor(el.getAttribute('data-plan-price'), n);
    });
  }

  // ---- Summary + billing explanation ----
  function monthName(d) { return ['January','February','March','April','May','June','July','August','September','October','November','December'][d.getMonth()]; }

  // Staff migration (phone mode): when a Start date is set, nothing is charged today.
  function scheduledStart() {
    if (!migrateMode) return '';
    var el = form.querySelector('input[name="start_date"]');
    return el && el.value ? el.value : '';
  }
  function prettyDate(ymd) {
    var p = String(ymd).split('-'); if (p.length !== 3) return ymd;
    return monthName(new Date(+p[0], +p[1] - 1, +p[2])) + ' ' + (+p[2]) + ', ' + p[0];
  }

  function refreshSummary() {
    var pk = plan(), n = bins(), charge = chargeToday(pk, n);
    var sched = scheduledStart();
    root.querySelector('[data-sum-plan]').textContent = PRICES[pk].name;
    root.querySelector('[data-sum-bins]').textContent = n;
    root.querySelector('[data-sum-price]').textContent = sched ? '$0 today' : ('$' + charge);

    var note = '', explain = '';
    var today = new Date();
    if (sched) {
      note = 'Scheduled — first charge on ' + prettyDate(sched) + '.';
      explain = 'No charge today. The saved card will first be charged $' + priceFor(pk, n) + ' on ' + prettyDate(sched) + ', then ' + PRICES[pk].cadence + ' on that date.';
    } else if (pk === 'ondemand') {
      note = 'One-time service — no recurring billing.';
      explain = 'You’ll be charged $' + charge + ' today for a one-time On Demand cleaning of ' + n + ' bin' + (n > 1 ? 's' : '') + '. There is no recurring charge.';
    } else {
      var next = new Date(today.getFullYear(), today.getMonth() + PRICES[pk].months, 1);
      var label = monthName(next) + ' ' + next.getFullYear();
      note = 'Renews ' + PRICES[pk].cadence + '. Future charges on the 1st of the service month.';
      explain = 'You’ll be charged $' + charge + ' today for your first service. Your next ' + PRICES[pk].cadence + ' service falls in ' + label + ', and that service will be billed on ' + monthName(next) + ' 1st, ' + next.getFullYear() + '. All future charges occur on the 1st of the month your service takes place.';
    }
    root.querySelector('[data-sum-note]').textContent = note;
    var ex = root.querySelector('[data-billing-explain]'); if (ex) ex.textContent = explain;
  }

  // ---- Review block (step 4) ----
  function refreshReview() {
    var fd = new FormData(form);
    var pk = plan(), n = bins(), price = priceFor(pk, n), off = couponOff(price);
    var rows = [
      ['Plan', PRICES[pk].name],
      ['Bins', n],
      ['Name', (fd.get('first_name') || '') + ' ' + (fd.get('last_name') || '')],
      ['Email', fd.get('email') || ''],
      ['Phone', fd.get('phone') || ''],
      ['Service address', [fd.get('service_address'), fd.get('service_city'), fd.get('service_zip')].filter(Boolean).join(', ')],
      ['Trash day', fd.get('trash_day') || ''],
      ['Emptied by', fd.get('emptied_by') || '']
    ];
    if (off > 0) rows.push(['Coupon' + (coupon && coupon.code ? ' (' + coupon.code + ')' : ''), '−$' + (Math.round(off * 100) / 100)]);
    var _sched = scheduledStart();
    rows.push(_sched ? ['Charged today', '$0 — first charge ' + prettyDate(_sched)] : ['Today’s charge', '$' + chargeToday(pk, n)]);
    var el = root.querySelector('[data-review]');
    if (el) el.innerHTML = rows.map(function (r) {
      return '<div class="summary-row"><span>' + r[0] + '</span><strong>' + (r[1] || '—') + '</strong></div>';
    }).join('');
  }

  // ---- Service-area ZIP check (dropdown of in-area ZIPs) ----
  var zipInput = document.getElementById('service-zip');
  var zipMsg = root.querySelector('[data-zip-msg]');
  if (zipInput) {
    zipInput.addEventListener('change', function () {
      var v = zipInput.value;
      if (!v) { zipMsg.textContent = ''; zipMsg.className = 'zip-msg'; return; }
      if (v === 'other') {
        zipMsg.textContent = 'Sorry, that’s outside our current service area. Call 818-925-BINS — we’re always expanding!';
        zipMsg.className = 'zip-msg zip-msg--warn';
      } else {
        zipMsg.textContent = '✓ Great — we service your area!';
        zipMsg.className = 'zip-msg zip-msg--ok';
      }
    });
  }

  // ---- Billing address toggle ----
  var billingSame = document.getElementById('billing-same');
  var billingBlock = document.getElementById('billing-address');
  if (billingSame && billingBlock) {
    billingSame.addEventListener('change', function () { billingBlock.hidden = billingSame.checked; });
  }

  // ---- Coupon "Apply" — previews the discount (backend re-checks + applies at charge) ----
  var promoApply = document.getElementById('coupon-apply');
  var promoInput = document.getElementById('coupon-code');
  var promoMsg = document.getElementById('coupon-msg');
  if (promoApply && promoInput) {
    promoApply.addEventListener('click', function () {
      var code = (promoInput.value || '').trim();
      coupon = null;
      if (!code) { if (promoMsg) { promoMsg.textContent = ''; promoMsg.className = 'promo-msg'; } refreshSummary(); return; }
      if (!BACKEND) return;
      promoApply.disabled = true; promoApply.textContent = '…';
      fetch(BACKEND + '/api/config?promo=' + encodeURIComponent(code))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          promoApply.disabled = false; promoApply.textContent = 'Apply';
          if (d && d.valid) {
            coupon = { percent_off: d.percent_off, amount_off: d.amount_off, code: d.code };
            if (promoMsg) { promoMsg.className = 'promo-msg promo-msg--ok'; promoMsg.textContent = 'Coupon applied — $' + couponOff(priceFor(plan(), bins())) + ' off your first service.'; }
          } else if (promoMsg) {
            promoMsg.className = 'promo-msg promo-msg--warn';
            promoMsg.textContent = 'That’s not a valid coupon code. Please double-check and try again.';
          }
          refreshSummary();
        })
        .catch(function () { promoApply.disabled = false; promoApply.textContent = 'Apply'; });
    });
  }

  // ---- Referral "Apply" — disabled (Partner Referral Program coming soon) ----
  // The referral input field has been removed from the form.
  // The hidden input still sends referral_code to the backend for future use.

  // ---- Staff sign-up modes (hidden from the public website) ----
  //   ?phone=1            → Action 1: sign up a NEW customer (all 5 plans; creates a Workiz lead)
  //   ?phone=1&migrate=1  → Action 2: migrate an EXISTING customer (adds card, optional start date,
  //                          NO Workiz lead — suppressed by a flag the Workiz Zap filters on)
  var migrateMode = /[?&]migrate=1/.test(location.search);
  var phoneMode = /[?&]phone=1/.test(location.search) || migrateMode;
  if (phoneMode) {
    var pwInput = document.getElementById('password-input');
    var pwNote = document.getElementById('phone-signup-note');
    var pwField = document.getElementById('password-field');
    if (pwInput) { pwInput.required = false; pwInput.value = ''; }
    var pwLabel = pwField && pwField.querySelector('label');
    if (pwLabel) pwLabel.innerHTML = 'Create a password <small>(optional — leave blank for phone sign-ups)</small>';
    if (pwNote) pwNote.hidden = false;
  }
  if (migrateMode) {
    // Reveal the migration "Start date" field (existing customers only).
    root.querySelectorAll('[data-phone-only]').forEach(function (el) { el.style.display = ''; });
    var startInput = form.querySelector('input[name="start_date"]');
    if (startInput) startInput.addEventListener('change', function () { refreshSummary(); refreshReview(); });
  }

  // ---- Custom-plan sign-up link (?plans=custom): show ONLY Bi-Monthly / Bi-Annual ----
  // These plans are never shown on the public site. The owner shares this link (from the
  // admin dashboard) with a customer who's agreed to one of them; they then sign up as normal.
  var customMode = /[?&]plans=custom/.test(location.search);
  var hiddenCards = [].slice.call(root.querySelectorAll('[data-hidden-plan]'));
  var publicCards = [].slice.call(root.querySelectorAll('.plan-select:not([data-hidden-plan])'));
  function setPlanShown(card, shown) {
    card.style.display = shown ? '' : 'none';
    var input = card.querySelector('input[name="plan"]');
    if (input) { input.disabled = !shown; if (!shown) input.checked = false; }
  }
  if (customMode) {
    publicCards.forEach(function (c) { setPlanShown(c, false); });
    hiddenCards.forEach(function (c) { setPlanShown(c, true); });
    var firstCustom = hiddenCards[0] && hiddenCards[0].querySelector('input[name="plan"]');
    if (firstCustom) firstCustom.checked = true;
    refreshPlanPrices(); refreshSummary();
  } else if (phoneMode) {
    // Staff sign-up (Action 1 & 2): show ALL five plans, incl. Bi-Monthly / Bi-Annual.
    hiddenCards.forEach(function (c) { setPlanShown(c, true); });
    refreshPlanPrices(); refreshSummary();
  } else {
    // Public form: keep the custom plans hidden and un-submittable.
    hiddenCards.forEach(function (c) { setPlanShown(c, false); });
  }

  // ---- Abandoned-cart: capture the lead as soon as we have an email ----
  // (Details + Payment are one step now, so we no longer wait for a step change.)
  var emailField = form.querySelector('input[name="email"]');
  if (emailField) emailField.addEventListener('blur', function () { if (emailField.value) trackLead(); });

  // ---- Phone: US format as you type -> (555) 123-4567. Digits only are sent to the backend. ----
  function phoneDigits(v) {
    var d = String(v || '').replace(/\D/g, '');
    // Autofill/paste often gives +1 818… — drop the US country code so it doesn't shift the digits.
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    return d.slice(0, 10);
  }
  function fmtUsPhone(v) {
    var d = phoneDigits(v);
    if (d.length < 4) return d;
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + (d.length > 6 ? '-' + d.slice(6) : '');
  }
  var phoneField = form.querySelector('input[name="phone"]');
  if (phoneField) phoneField.addEventListener('input', function () {
    var atEnd = phoneField.selectionStart === phoneField.value.length;
    phoneField.value = fmtUsPhone(phoneField.value);
    // Keep the caret at the end when typing straight through; leave it alone when editing mid-number.
    if (atEnd) { var p = phoneField.value.length; phoneField.setSelectionRange(p, p); }
  });
  var bzip = form.querySelector('input[name="billing_zip"]');
  if (bzip) bzip.addEventListener('input', function () { bzip.value = bzip.value.replace(/\D/g, '').slice(0, 5); });

  // ---- Google Places (New API) address autocomplete — custom dropdown, optional ----
  var placesReady = false;
  function wirePlacesAutocomplete() {
    if (placesReady) return;
    var P = window.google && google.maps && google.maps.places;
    if (!(P && P.AutocompleteSuggestion && P.AutocompleteSessionToken)) return;
    var street = document.getElementById('service-address');
    var box = document.getElementById('addr-suggestions');
    if (!street || !box) return;
    placesReady = true;

    var token = new P.AutocompleteSessionToken();
    var items = [], activeIdx = -1, timer = null;
    var cityInput = form.querySelector('input[name="service_city"]');

    function close() { box.hidden = true; box.innerHTML = ''; items = []; activeIdx = -1; }

    function fillFrom(place) {
      var comps = place.addressComponents || [];
      function comp(type) {
        for (var k = 0; k < comps.length; k++) { if (comps[k].types.indexOf(type) > -1) return comps[k]; }
        return null;
      }
      var num = comp('street_number'), route = comp('route');
      var city = comp('locality') || comp('sublocality') || comp('postal_town');
      var zip = comp('postal_code');
      if (route) street.value = (num ? num.longText + ' ' : '') + route.longText;
      if (cityInput && city) cityInput.value = city.longText;
      if (zip && zipInput) {
        var z = zip.longText;
        zipInput.value = ZIPS.indexOf(z) > -1 ? z : 'other';
        zipInput.dispatchEvent(new Event('change')); // run our service-area check
      }
    }

    function choose(i) {
      var s = items[i]; if (!s || !s.placePrediction) return;
      var place = s.placePrediction.toPlace();
      place.fetchFields({ fields: ['addressComponents'] }).then(function () {
        fillFrom(place);
        token = new P.AutocompleteSessionToken(); // start a fresh billing session after a pick
        close();
      }).catch(function () { close(); });
    }

    function render(suggestions) {
      items = suggestions || [];
      activeIdx = -1;
      if (!items.length) { close(); return; }
      box.innerHTML = '';
      items.forEach(function (s, i) {
        if (!s.placePrediction) return;
        var el = document.createElement('div');
        el.className = 'addr-suggestions__item';
        el.setAttribute('role', 'option');
        el.textContent = s.placePrediction.text ? s.placePrediction.text.toString() : '';
        el.addEventListener('mousedown', function (e) { e.preventDefault(); choose(i); });
        box.appendChild(el);
      });
      box.hidden = false;
    }

    function fetchSuggest(input) {
      P.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: input, sessionToken: token, includedRegionCodes: ['us']
      }).then(function (res) { render(res.suggestions); }).catch(function () { close(); });
    }

    street.addEventListener('input', function () {
      var v = street.value.trim();
      if (timer) clearTimeout(timer);
      if (v.length < 3) { close(); return; }
      timer = setTimeout(function () { fetchSuggest(v); }, 220);
    });
    street.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      var n = box.querySelectorAll('.addr-suggestions__item');
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(n.length - 1, activeIdx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(0, activeIdx - 1); }
      else if (e.key === 'Enter') { if (activeIdx > -1) { e.preventDefault(); choose(activeIdx); } return; }
      else if (e.key === 'Escape') { close(); return; }
      n.forEach(function (el, idx) { el.classList.toggle('is-active', idx === activeIdx); });
    });
    document.addEventListener('click', function (e) { if (e.target !== street && !box.contains(e.target)) close(); });
  }
  window.cbInitPlaces = wirePlacesAutocomplete;           // Google Maps script calls this when ready
  wirePlacesAutocomplete();                               // in case the library loaded first

  // ---- Bin counter ----
  root.querySelectorAll('[data-bins]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('bin-count');
      var min = plan() === 'ondemand' ? 2 : 1;
      var v = (parseInt(input.value, 10) || 2) + parseInt(btn.getAttribute('data-bins'), 10);
      input.value = Math.max(min, Math.min(20, v));
      refreshPlanPrices(); refreshSummary();
    });
  });
  form.querySelectorAll('input[name="plan"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var input = document.getElementById('bin-count');
      if (plan() === 'ondemand' && (parseInt(input.value, 10) || 2) < 2) input.value = 2;
      refreshPlanPrices(); refreshSummary();
    });
  });

  // ---- Step navigation ----
  var done = false;
  function show(i) {
    if (done || !steps[current]) return;
    steps[current].classList.remove('is-active');
    current = Math.max(0, Math.min(steps.length - 1, i));
    steps[current].classList.add('is-active');
    pSteps.forEach(function (p, idx) { p.classList.toggle('is-active', idx <= current); });
    window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' });
  }
  function validateStep(i) {
    var req = steps[i].querySelectorAll('[required]');
    for (var k = 0; k < req.length; k++) {
      if (!req[k].checkValidity()) { req[k].reportValidity(); return false; }
    }
    return true;
  }
  // Each "Continue" pushes a history entry, so the BROWSER Back button (and the in-form Back)
  // returns to the previous step instead of leaving the page to the homepage.
  root.querySelectorAll('[data-next]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!validateStep(current)) return;
      var n = Math.min(steps.length - 1, current + 1);
      show(n);
      history.pushState({ cbStep: n }, '', '#step-' + (n + 1));
    });
  });

  // ---- Review modal (opens from step 2 so payment stays "on step 2") ----
  var reviewModal = document.getElementById('review-modal');
  function openReview() {
    if (!validateStep(current)) return;                // details valid
    if (stripe && cardElement && !cardComplete) {       // card valid
      var ce = document.getElementById('card-step-error');
      if (ce) { ce.textContent = 'Please enter your card details to continue.'; ce.style.display = 'block'; }
      return;
    }
    refreshReview(); refreshSummary();
    if (reviewModal) reviewModal.hidden = false;
    document.body.classList.add('signup-modal-open');
    history.pushState({ cbStep: current, modal: true }, '', '#review');
  }
  function closeReview() {
    if (reviewModal) reviewModal.hidden = true;
    document.body.classList.remove('signup-modal-open');
  }
  var openBtn = document.getElementById('open-review');
  if (openBtn) openBtn.addEventListener('click', openReview);
  root.querySelectorAll('[data-close-review]').forEach(function (b) { b.addEventListener('click', closeReview); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && reviewModal && !reviewModal.hidden) closeReview(); });
  root.querySelectorAll('[data-prev]').forEach(function (b) {
    b.addEventListener('click', function () { history.back(); }); // same as browser Back → previous step
  });
  window.addEventListener('popstate', function (e) {
    if (reviewModal && !reviewModal.hidden) closeReview();
    var s = (e.state && typeof e.state.cbStep === 'number') ? e.state.cbStep : 0;
    show(s);
  });
  history.replaceState({ cbStep: 0 }, '', location.pathname + location.search);

  // ---- Stripe setup ----
  var PK = root.dataset.pk || '';
  var BACKEND = (root.dataset.backend || '').replace(/\/$/, '');
  var stripe, cardElement, paymentRequest, cardComplete = false;

  function setStatus(msg, kind) {
    var el = document.getElementById('signup-status');
    if (!el) { el = document.createElement('p'); el.id = 'signup-status'; var slot = document.getElementById('signup-status-slot'); if (slot) slot.appendChild(el); }
    el.className = kind === 'error' ? 'form-error' : 'form-success';
    el.textContent = msg;
  }

  // ---- Abandoned-cart lead capture (fires when user reaches the payment step) ----
  var leadTracked = false;
  function trackLead() {
    if (!BACKEND || leadTracked) return;
    var fd = new FormData(form);
    var email = fd.get('email');
    if (!email) return;
    leadTracked = true;
    fetch(BACKEND + '/api/track-lead', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, first_name: fd.get('first_name'), plan: plan(), bins: bins() })
    }).catch(function () { leadTracked = false; });
  }

  if (PK && window.Stripe) {
    stripe = Stripe(PK);
    var elements = stripe.elements({ fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap' }] });
    var style = { base: { fontFamily: 'Poppins, sans-serif', fontSize: '16px', color: '#1a1a1a', '::placeholder': { color: '#9aa3b2' } } };
    cardElement = elements.create('card', { style: style, disableLink: phoneMode }); // no Link wallet prompt on staff phone sign-ups
    var mount = document.getElementById('card-element');
    if (mount) { mount.innerHTML = ''; cardElement.mount('#card-element'); }
    cardElement.on('change', function (e) {
      cardComplete = e.complete;
      var ce = document.getElementById('card-step-error');
      if (ce) {
        if (e.error) { ce.textContent = e.error.message; ce.style.display = 'block'; }
        else { ce.style.display = 'none'; }
      }
    });

    // Apple Pay / Google Pay / Link wallet — PUBLIC form only. On staff phone sign-ups the
    // staff type the customer's card, so the wallet (and its Link "Pay $X" popup) is skipped.
    if (!phoneMode) {
      paymentRequest = stripe.paymentRequest({
        country: 'US', currency: 'usd',
        total: { label: 'Clean Bins 360 — first service', amount: Math.round(chargeToday(plan(), bins()) * 100) },
        requestPayerName: true, requestPayerEmail: true
      });
      var prEl = elements.create('paymentRequestButton', { paymentRequest: paymentRequest });
      paymentRequest.canMakePayment().then(function (result) {
        if (result) {
          prEl.mount('#payment-request-button');
          var wn = document.getElementById('wallet-note'); if (wn) wn.hidden = false;
        } else {
          var c = document.getElementById('payment-request-button'); if (c) c.style.display = 'none';
        }
      });
      paymentRequest.on('paymentmethod', function (ev) {
        submitToBackend(ev.paymentMethod.id, ev);
      });
    } else {
      var prc = document.getElementById('payment-request-button'); if (prc) prc.style.display = 'none';
      var wnote = document.getElementById('wallet-note'); if (wnote) wnote.hidden = true;
      form.querySelectorAll('.signup__hint').forEach(function (h) { // retitle the "Apple Pay supported" hint
        if (/Apple Pay/.test(h.textContent)) h.textContent = 'Type the customer’s card below — it’s securely saved for their subscription.';
      });
    }
  }

  function gatherData(pmId) {
    var fd = new FormData(form);
    var bsame = document.getElementById('billing-same');
    return {
      plan: plan(), bins: bins(), payment_method_id: pmId,
      first_name: fd.get('first_name'), last_name: fd.get('last_name'),
      email: fd.get('email'), phone: phoneDigits(fd.get('phone')), password: fd.get('password'),
      service_address: fd.get('service_address'), service_city: fd.get('service_city'), service_zip: fd.get('service_zip'),
      billing_same: !bsame || bsame.checked,
      billing_address: fd.get('billing_address') || '', billing_city: fd.get('billing_city') || '', billing_zip: fd.get('billing_zip') || '',
      trash_day: fd.get('trash_day'), emptied_by: fd.get('emptied_by'), how_heard: fd.get('how_heard'),
      gate_code: fd.get('gate_code'), instructions: fd.get('instructions'),
      coupon_code: fd.get('coupon_code') || '', referral_code: fd.get('referral_code') || '',
      phone_signup: phoneMode,
      migrate: migrateMode,
      start_date: migrateMode ? (fd.get('start_date') || '') : ''
    };
  }

  function showSuccess(data) {
    done = true;
    document.body.classList.remove('signup-modal-open');
    var box = root.querySelector('.signup__form');
    var msg = (data && data.scheduled && data.nextBillingLabel)
      ? 'The card is saved and <strong>nothing was charged today</strong>. The first charge is scheduled for <strong>' + data.nextBillingLabel + '</strong>, then billing continues on that date.'
      : 'Thanks for signing up with Clean Bins 360. A confirmation is on its way to your email, and we’ll schedule your first service shortly.';
    box.innerHTML = '<div class="signup__done"><h2>You’re all set! 🎉</h2>' +
      '<p>' + msg + '</p>' +
      '<a class="btn btn--primary" href="/">Back to Home</a></div>';
    window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' });
  }

  function submitToBackend(pmId, prEvent) {
    if (!BACKEND) { setStatus('Payment backend not configured yet (add the Vercel URL in theme settings).', 'error'); if (prEvent) prEvent.complete('fail'); return; }
    var btn = document.getElementById('signup-submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Processing…'; }
    setStatus('Processing your payment…', 'ok');

    fetch(BACKEND + '/api/create-subscription', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(gatherData(pmId))
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.error) { if (prEvent) prEvent.complete('fail'); setStatus(data.error, 'error'); if (btn) { btn.disabled = false; btn.innerHTML = 'Complete Sign Up <span class="arrow">&rarr;</span>'; } return; }
      if (prEvent) prEvent.complete('success');
      if (data.requiresAction && data.clientSecret) {
        stripe.confirmCardPayment(data.clientSecret).then(function (res) {
          if (res.error) { setStatus(res.error.message, 'error'); if (btn) { btn.disabled = false; btn.innerHTML = 'Complete Sign Up <span class="arrow">&rarr;</span>'; } }
          else { showSuccess(data); }
        });
        return;
      }
      showSuccess(data);
    }).catch(function () {
      if (prEvent) prEvent.complete('fail');
      setStatus('Network error — please try again.', 'error');
      if (btn) { btn.disabled = false; btn.innerHTML = 'Complete Sign Up <span class="arrow">&rarr;</span>'; }
    });
  }

  // ---- Submit ----
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var agree = document.getElementById('agree');
    if (agree && !agree.checked) { agree.reportValidity(); return; }
    if (!stripe || !cardElement) { setStatus('Payment is not configured yet. Add your Stripe key + backend URL in theme settings.', 'error'); return; }
    if (!cardComplete) { setStatus('Please enter your card details.', 'error'); return; }
    var fd = new FormData(form);
    setStatus('Securing your card…', 'ok');
    var bsame = document.getElementById('billing-same');
    var bAddr = (!bsame || bsame.checked)
      ? { line1: fd.get('service_address') || '', city: fd.get('service_city') || '', postal_code: fd.get('service_zip') || '', country: 'US' }
      : { line1: fd.get('billing_address') || '', city: fd.get('billing_city') || '', postal_code: fd.get('billing_zip') || '', country: 'US' };
    stripe.createPaymentMethod({
      type: 'card', card: cardElement,
      billing_details: { name: [fd.get('first_name'), fd.get('last_name')].filter(Boolean).join(' '), email: fd.get('email'), phone: phoneDigits(fd.get('phone')), address: bAddr }
    }).then(function (res) {
      if (res.error) { setStatus(res.error.message, 'error'); return; }
      submitToBackend(res.paymentMethod.id, null);
    });
  });

  // keep Apple/Google Pay total in sync
  var _origSummary = refreshSummary;
  refreshSummary = function () { _origSummary(); if (paymentRequest) { try { paymentRequest.update({ total: { label: 'Clean Bins 360 — first service', amount: Math.round(chargeToday(plan(), bins()) * 100) } }); } catch (e) {} } };

  // init
  var mRef = window.location.search.match(/[?&]ref=([^&]+)/);
  if (mRef) {
    var refInput = document.getElementById('referral-code');
    if (refInput) refInput.value = decodeURIComponent(mRef[1]).trim().toUpperCase();
  }

  refreshPlanPrices();
  refreshSummary();
})();
